var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.visible)?_c('Toast',{attrs:{"title":_vm.title,"description":_vm.description,"placement":_vm.placement,"variant":_vm.variant},on:{"close":_vm.hide}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }